module.exports = __webpack_public_path__ + "media/images/places_banner-c1273b4ad3eb3c901f001ea7cd810932.png";